import { registerHandler } from '../paymentHandlerRegistry';

/**
 * Nequi payment handler.
 * Handle Nequi transfer payments by calling transferPaymentAttempt directly.
 * NequiForm is informational-only (no redux-form registered), so the payment
 * action is dispatched without form data, matching the regular Checkout behavior.
 */
const nequiPaymentHandler = {
  canHandle: ({ selectedPaymentMethod }) => selectedPaymentMethod?.provider === 'nequi',

  execute: async ({ purchase, onTransferPaymentAttempt }) => {
    const { token, selectedPaymentMethod } = purchase;
    onTransferPaymentAttempt({
      purchaseToken: token,
      engine: selectedPaymentMethod?.engine,
      provider: selectedPaymentMethod?.provider,
    });
  },
};

registerHandler('transfer', nequiPaymentHandler);
